import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { DELETE_DMX_PROFILE } from './actionTypes';
import { deleteDmxProfileSuccessful, deleteDmxProfileFailed } from './actions';

import { getDmxAPI } from '../../../api/dmx';

const dmxAPI = getDmxAPI();

function* deleteProfile({ payload: { profile } }) {
  try {
    const response = yield call(dmxAPI.deleteProfile, profile.token, profile.id);
    if (response.message) {
      yield put(deleteDmxProfileSuccessful(response.message));
    } else throw response.error;
  } catch (error) {
    yield put(deleteDmxProfileFailed(error));
  }
}

export function* watchDeleteDmxProfile() {
  yield takeEvery(DELETE_DMX_PROFILE, deleteProfile);
}

function* deleteDmxProfileSaga() {
  yield all([fork(watchDeleteDmxProfile)]);
}

export default deleteDmxProfileSaga;
